module.exports = __webpack_public_path__ + "static/media/genisis3.15c5fd1a.jpg";